import { render, staticRenderFns } from "./MatterFinalizationList.vue?vue&type=template&id=75a1aca4&"
import script from "./MatterFinalizationList.vue?vue&type=script&lang=js&"
export * from "./MatterFinalizationList.vue?vue&type=script&lang=js&"
import style0 from "./MatterFinalizationList.vue?vue&type=style&index=0&id=75a1aca4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports